module.exports = "<p>אם שכחתם את הסיסמא תוכלו לשחזר אותה באמצעות כתובת המייל שלכם. אנחנו נשלח לכם מייל סיוע.</p> ";


//////////////////
// WEBPACK FOOTER
// ./src/translations/help/he/2.md
// module id = 799
// module chunks = 0